/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DocumentsRouteImport } from './routes/documents'
import { Route as ExpensesRouteImport } from './routes/expenses'
import { Route as FinanceRouteImport } from './routes/finance'
import { Route as GapsRouteImport } from './routes/gaps'
import { Route as HoursRouteImport } from './routes/hours'
import { Route as InvoicesRouteImport } from './routes/invoices'
import { Route as OverviewRouteImport } from './routes/overview'
import { Route as PayoutsRouteImport } from './routes/payouts'
import { Route as PayplanRouteImport } from './routes/payplan'
import { Route as ReceiptsRouteImport } from './routes/receipts'
import { Route as RosterRouteImport } from './routes/roster'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as ClientsIndexRouteImport } from './routes/clients.index'
import { Route as ClientsIdRouteImport } from './routes/clients.$id'
import { Route as EntitiesIndexRouteImport } from './routes/entities.index'
import { Route as EntitiesIdRouteImport } from './routes/entities.$id'
import { Route as PeopleIndexRouteImport } from './routes/people.index'
import { Route as PeopleIdRouteImport } from './routes/people.$id'
import { Route as ProjectsIndexRouteImport } from './routes/projects.index'
import { Route as ProjectsIdRouteImport } from './routes/projects.$id'
import { Route as SettingsIndexRouteImport } from './routes/settings.index'
import { Route as SettingsBackupsRouteImport } from './routes/settings.backups'
import { Route as SettingsBusinessLinesRouteImport } from './routes/settings.business-lines'
import { Route as SettingsCalendarsRouteImport } from './routes/settings.calendars'
import { Route as SettingsDataRouteImport } from './routes/settings.data'
import { Route as SettingsExpensesRouteImport } from './routes/settings.expenses'
import { Route as SettingsFxRouteImport } from './routes/settings.fx'
import { Route as SettingsRolesRouteImport } from './routes/settings.roles'
import { Route as SettingsTemplatesRouteImport } from './routes/settings.templates'
import { Route as SettingsUsersRouteImport } from './routes/settings.users'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsRoute = DocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => rootRouteImport,
} as any)
const ExpensesRoute = ExpensesRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => rootRouteImport,
} as any)
const FinanceRoute = FinanceRouteImport.update({
  id: '/finance',
  path: '/finance',
  getParentRoute: () => rootRouteImport,
} as any)
const GapsRoute = GapsRouteImport.update({
  id: '/gaps',
  path: '/gaps',
  getParentRoute: () => rootRouteImport,
} as any)
const HoursRoute = HoursRouteImport.update({
  id: '/hours',
  path: '/hours',
  getParentRoute: () => rootRouteImport,
} as any)
const InvoicesRoute = InvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => rootRouteImport,
} as any)
const OverviewRoute = OverviewRouteImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => rootRouteImport,
} as any)
const PayoutsRoute = PayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => rootRouteImport,
} as any)
const PayplanRoute = PayplanRouteImport.update({
  id: '/payplan',
  path: '/payplan',
  getParentRoute: () => rootRouteImport,
} as any)
const ReceiptsRoute = ReceiptsRouteImport.update({
  id: '/receipts',
  path: '/receipts',
  getParentRoute: () => rootRouteImport,
} as any)
const RosterRoute = RosterRouteImport.update({
  id: '/roster',
  path: '/roster',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsIndexRoute = ClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => rootRouteImport,
} as any)
const ClientsIdRoute = ClientsIdRouteImport.update({
  id: '/clients/$id',
  path: '/clients/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const EntitiesIndexRoute = EntitiesIndexRouteImport.update({
  id: '/entities/',
  path: '/entities/',
  getParentRoute: () => rootRouteImport,
} as any)
const EntitiesIdRoute = EntitiesIdRouteImport.update({
  id: '/entities/$id',
  path: '/entities/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleIndexRoute = PeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => rootRouteImport,
} as any)
const PeopleIdRoute = PeopleIdRouteImport.update({
  id: '/people/$id',
  path: '/people/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIdRoute = ProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBackupsRoute = SettingsBackupsRouteImport.update({
  id: '/backups',
  path: '/backups',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsBusinessLinesRoute = SettingsBusinessLinesRouteImport.update({
  id: '/business-lines',
  path: '/business-lines',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCalendarsRoute = SettingsCalendarsRouteImport.update({
  id: '/calendars',
  path: '/calendars',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsDataRoute = SettingsDataRouteImport.update({
  id: '/data',
  path: '/data',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsExpensesRoute = SettingsExpensesRouteImport.update({
  id: '/expenses',
  path: '/expenses',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsFxRoute = SettingsFxRouteImport.update({
  id: '/fx',
  path: '/fx',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsRolesRoute = SettingsRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsTemplatesRoute = SettingsTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsUsersRoute = SettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => SettingsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/documents': typeof DocumentsRoute
  '/expenses': typeof ExpensesRoute
  '/finance': typeof FinanceRoute
  '/gaps': typeof GapsRoute
  '/hours': typeof HoursRoute
  '/invoices': typeof InvoicesRoute
  '/overview': typeof OverviewRoute
  '/payouts': typeof PayoutsRoute
  '/payplan': typeof PayplanRoute
  '/receipts': typeof ReceiptsRoute
  '/roster': typeof RosterRoute
  '/settings': typeof SettingsRouteWithChildren
  '/clients/$id': typeof ClientsIdRoute
  '/entities/$id': typeof EntitiesIdRoute
  '/people/$id': typeof PeopleIdRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/settings/backups': typeof SettingsBackupsRoute
  '/settings/business-lines': typeof SettingsBusinessLinesRoute
  '/settings/calendars': typeof SettingsCalendarsRoute
  '/settings/data': typeof SettingsDataRoute
  '/settings/expenses': typeof SettingsExpensesRoute
  '/settings/fx': typeof SettingsFxRoute
  '/settings/roles': typeof SettingsRolesRoute
  '/settings/templates': typeof SettingsTemplatesRoute
  '/settings/users': typeof SettingsUsersRoute
  '/clients/': typeof ClientsIndexRoute
  '/entities/': typeof EntitiesIndexRoute
  '/people/': typeof PeopleIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/documents': typeof DocumentsRoute
  '/expenses': typeof ExpensesRoute
  '/finance': typeof FinanceRoute
  '/gaps': typeof GapsRoute
  '/hours': typeof HoursRoute
  '/invoices': typeof InvoicesRoute
  '/overview': typeof OverviewRoute
  '/payouts': typeof PayoutsRoute
  '/payplan': typeof PayplanRoute
  '/receipts': typeof ReceiptsRoute
  '/roster': typeof RosterRoute
  '/clients/$id': typeof ClientsIdRoute
  '/entities/$id': typeof EntitiesIdRoute
  '/people/$id': typeof PeopleIdRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/settings/backups': typeof SettingsBackupsRoute
  '/settings/business-lines': typeof SettingsBusinessLinesRoute
  '/settings/calendars': typeof SettingsCalendarsRoute
  '/settings/data': typeof SettingsDataRoute
  '/settings/expenses': typeof SettingsExpensesRoute
  '/settings/fx': typeof SettingsFxRoute
  '/settings/roles': typeof SettingsRolesRoute
  '/settings/templates': typeof SettingsTemplatesRoute
  '/settings/users': typeof SettingsUsersRoute
  '/clients': typeof ClientsIndexRoute
  '/entities': typeof EntitiesIndexRoute
  '/people': typeof PeopleIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/settings': typeof SettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/documents': typeof DocumentsRoute
  '/expenses': typeof ExpensesRoute
  '/finance': typeof FinanceRoute
  '/gaps': typeof GapsRoute
  '/hours': typeof HoursRoute
  '/invoices': typeof InvoicesRoute
  '/overview': typeof OverviewRoute
  '/payouts': typeof PayoutsRoute
  '/payplan': typeof PayplanRoute
  '/receipts': typeof ReceiptsRoute
  '/roster': typeof RosterRoute
  '/settings': typeof SettingsRouteWithChildren
  '/clients/$id': typeof ClientsIdRoute
  '/entities/$id': typeof EntitiesIdRoute
  '/people/$id': typeof PeopleIdRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/settings/backups': typeof SettingsBackupsRoute
  '/settings/business-lines': typeof SettingsBusinessLinesRoute
  '/settings/calendars': typeof SettingsCalendarsRoute
  '/settings/data': typeof SettingsDataRoute
  '/settings/expenses': typeof SettingsExpensesRoute
  '/settings/fx': typeof SettingsFxRoute
  '/settings/roles': typeof SettingsRolesRoute
  '/settings/templates': typeof SettingsTemplatesRoute
  '/settings/users': typeof SettingsUsersRoute
  '/clients/': typeof ClientsIndexRoute
  '/entities/': typeof EntitiesIndexRoute
  '/people/': typeof PeopleIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/documents'
    | '/expenses'
    | '/finance'
    | '/gaps'
    | '/hours'
    | '/invoices'
    | '/overview'
    | '/payouts'
    | '/payplan'
    | '/receipts'
    | '/roster'
    | '/settings'
    | '/clients/$id'
    | '/entities/$id'
    | '/people/$id'
    | '/projects/$id'
    | '/settings/backups'
    | '/settings/business-lines'
    | '/settings/calendars'
    | '/settings/data'
    | '/settings/expenses'
    | '/settings/fx'
    | '/settings/roles'
    | '/settings/templates'
    | '/settings/users'
    | '/clients/'
    | '/entities/'
    | '/people/'
    | '/projects/'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/documents'
    | '/expenses'
    | '/finance'
    | '/gaps'
    | '/hours'
    | '/invoices'
    | '/overview'
    | '/payouts'
    | '/payplan'
    | '/receipts'
    | '/roster'
    | '/clients/$id'
    | '/entities/$id'
    | '/people/$id'
    | '/projects/$id'
    | '/settings/backups'
    | '/settings/business-lines'
    | '/settings/calendars'
    | '/settings/data'
    | '/settings/expenses'
    | '/settings/fx'
    | '/settings/roles'
    | '/settings/templates'
    | '/settings/users'
    | '/clients'
    | '/entities'
    | '/people'
    | '/projects'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/documents'
    | '/expenses'
    | '/finance'
    | '/gaps'
    | '/hours'
    | '/invoices'
    | '/overview'
    | '/payouts'
    | '/payplan'
    | '/receipts'
    | '/roster'
    | '/settings'
    | '/clients/$id'
    | '/entities/$id'
    | '/people/$id'
    | '/projects/$id'
    | '/settings/backups'
    | '/settings/business-lines'
    | '/settings/calendars'
    | '/settings/data'
    | '/settings/expenses'
    | '/settings/fx'
    | '/settings/roles'
    | '/settings/templates'
    | '/settings/users'
    | '/clients/'
    | '/entities/'
    | '/people/'
    | '/projects/'
    | '/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DocumentsRoute: typeof DocumentsRoute
  ExpensesRoute: typeof ExpensesRoute
  FinanceRoute: typeof FinanceRoute
  GapsRoute: typeof GapsRoute
  HoursRoute: typeof HoursRoute
  InvoicesRoute: typeof InvoicesRoute
  OverviewRoute: typeof OverviewRoute
  PayoutsRoute: typeof PayoutsRoute
  PayplanRoute: typeof PayplanRoute
  ReceiptsRoute: typeof ReceiptsRoute
  RosterRoute: typeof RosterRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  ClientsIdRoute: typeof ClientsIdRoute
  EntitiesIdRoute: typeof EntitiesIdRoute
  PeopleIdRoute: typeof PeopleIdRoute
  ProjectsIdRoute: typeof ProjectsIdRoute
  ClientsIndexRoute: typeof ClientsIndexRoute
  EntitiesIndexRoute: typeof EntitiesIndexRoute
  PeopleIndexRoute: typeof PeopleIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents': {
      id: '/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof DocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/expenses': {
      id: '/expenses'
      path: '/expenses'
      fullPath: '/expenses'
      preLoaderRoute: typeof ExpensesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/finance': {
      id: '/finance'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof FinanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gaps': {
      id: '/gaps'
      path: '/gaps'
      fullPath: '/gaps'
      preLoaderRoute: typeof GapsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hours': {
      id: '/hours'
      path: '/hours'
      fullPath: '/hours'
      preLoaderRoute: typeof HoursRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invoices': {
      id: '/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof InvoicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/overview': {
      id: '/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof OverviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payouts': {
      id: '/payouts'
      path: '/payouts'
      fullPath: '/payouts'
      preLoaderRoute: typeof PayoutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payplan': {
      id: '/payplan'
      path: '/payplan'
      fullPath: '/payplan'
      preLoaderRoute: typeof PayplanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/receipts': {
      id: '/receipts'
      path: '/receipts'
      fullPath: '/receipts'
      preLoaderRoute: typeof ReceiptsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/roster': {
      id: '/roster'
      path: '/roster'
      fullPath: '/roster'
      preLoaderRoute: typeof RosterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/': {
      id: '/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof ClientsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clients/$id': {
      id: '/clients/$id'
      path: '/clients/$id'
      fullPath: '/clients/$id'
      preLoaderRoute: typeof ClientsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entities/': {
      id: '/entities/'
      path: '/entities'
      fullPath: '/entities/'
      preLoaderRoute: typeof EntitiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entities/$id': {
      id: '/entities/$id'
      path: '/entities/$id'
      fullPath: '/entities/$id'
      preLoaderRoute: typeof EntitiesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/': {
      id: '/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof PeopleIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/people/$id': {
      id: '/people/$id'
      path: '/people/$id'
      fullPath: '/people/$id'
      preLoaderRoute: typeof PeopleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$id': {
      id: '/projects/$id'
      path: '/projects/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof ProjectsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/backups': {
      id: '/settings/backups'
      path: '/backups'
      fullPath: '/settings/backups'
      preLoaderRoute: typeof SettingsBackupsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/business-lines': {
      id: '/settings/business-lines'
      path: '/business-lines'
      fullPath: '/settings/business-lines'
      preLoaderRoute: typeof SettingsBusinessLinesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/calendars': {
      id: '/settings/calendars'
      path: '/calendars'
      fullPath: '/settings/calendars'
      preLoaderRoute: typeof SettingsCalendarsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/data': {
      id: '/settings/data'
      path: '/data'
      fullPath: '/settings/data'
      preLoaderRoute: typeof SettingsDataRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/expenses': {
      id: '/settings/expenses'
      path: '/expenses'
      fullPath: '/settings/expenses'
      preLoaderRoute: typeof SettingsExpensesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/fx': {
      id: '/settings/fx'
      path: '/fx'
      fullPath: '/settings/fx'
      preLoaderRoute: typeof SettingsFxRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/roles': {
      id: '/settings/roles'
      path: '/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof SettingsRolesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/templates': {
      id: '/settings/templates'
      path: '/templates'
      fullPath: '/settings/templates'
      preLoaderRoute: typeof SettingsTemplatesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/users': {
      id: '/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof SettingsUsersRouteImport
      parentRoute: typeof SettingsRoute
    }
  }
}

interface SettingsRouteChildren {
  SettingsBackupsRoute: typeof SettingsBackupsRoute
  SettingsBusinessLinesRoute: typeof SettingsBusinessLinesRoute
  SettingsCalendarsRoute: typeof SettingsCalendarsRoute
  SettingsDataRoute: typeof SettingsDataRoute
  SettingsExpensesRoute: typeof SettingsExpensesRoute
  SettingsFxRoute: typeof SettingsFxRoute
  SettingsRolesRoute: typeof SettingsRolesRoute
  SettingsTemplatesRoute: typeof SettingsTemplatesRoute
  SettingsUsersRoute: typeof SettingsUsersRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsBackupsRoute: SettingsBackupsRoute,
  SettingsBusinessLinesRoute: SettingsBusinessLinesRoute,
  SettingsCalendarsRoute: SettingsCalendarsRoute,
  SettingsDataRoute: SettingsDataRoute,
  SettingsExpensesRoute: SettingsExpensesRoute,
  SettingsFxRoute: SettingsFxRoute,
  SettingsRolesRoute: SettingsRolesRoute,
  SettingsTemplatesRoute: SettingsTemplatesRoute,
  SettingsUsersRoute: SettingsUsersRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DocumentsRoute: DocumentsRoute,
  ExpensesRoute: ExpensesRoute,
  FinanceRoute: FinanceRoute,
  GapsRoute: GapsRoute,
  HoursRoute: HoursRoute,
  InvoicesRoute: InvoicesRoute,
  OverviewRoute: OverviewRoute,
  PayoutsRoute: PayoutsRoute,
  PayplanRoute: PayplanRoute,
  ReceiptsRoute: ReceiptsRoute,
  RosterRoute: RosterRoute,
  SettingsRoute: SettingsRouteWithChildren,
  ClientsIdRoute: ClientsIdRoute,
  EntitiesIdRoute: EntitiesIdRoute,
  PeopleIdRoute: PeopleIdRoute,
  ProjectsIdRoute: ProjectsIdRoute,
  ClientsIndexRoute: ClientsIndexRoute,
  EntitiesIndexRoute: EntitiesIndexRoute,
  PeopleIndexRoute: PeopleIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
